import { downloadFile, format, mapPaginationParamsToServer } from "@/shared";

import { mapInventoryFiltersToServer } from "./mappers/mapInventoryFiltersToServer";

export const exportInventories = async (paginationParams, filters) => {
    const fileName = `exported_inventories_${format(
        new Date(),
        "dd_MM_yyyy-HH_mm"
    )}`;

    await downloadFile("/inventory/export", fileName, {
        ...mapPaginationParamsToServer(paginationParams),
        ...mapInventoryFiltersToServer(filters),
    });
};
